module.exports = __webpack_public_path__ + "static/media/square-img2.0ab75b75.png";